import { FIELDS_TYPES } from 'src/api/config/type.config';
import { LookupFields, UrlFields, UserFields } from 'src/modules/modules.type';
import { LookUpRecord, UserRecord } from 'src/types/main';
import { LicenseStatuses } from '../../mocks/data';

export const prescriptionGos = 'Prescriptions';
export const locationsGos = 'Locations';
export const directionsGos = 'Directions';
export const prescriptionStatusGos = 'PrescriptionStatuses';
export const actionStatusGos = 'ActionStatuses';
export const gosViolations = 'ViolationsGos';
export const typeActivity = 'Activities';
export const typeDocument = 'DocumentTypes';
export const licenseStatus = 'LicenseStatuses';
export const agencyGovernment = 'GovernmentAgencies';
export const licensesList = 'Licenses';
export const GOScontactsListName = 'Contacts';
export const GOSinstructionsFilesLibName = 'Instructions';
export const SettingsListName = 'Settings';
export const PrescriptionsUpLoad = 'PrescriptionUpload';
export const LicensesUpLoad = 'LicensesUpload';

export const MyGoslistNameFields = {
  [prescriptionGos]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    PrescriptionNumber: FIELDS_TYPES.STRING,
    Direction: FIELDS_TYPES.LOOKUP,
    Responsible: FIELDS_TYPES.USER,
    GOSLocation: FIELDS_TYPES.LOOKUP,
    DateVerification: FIELDS_TYPES.DATE,
    DeadlineExecutionOrder: FIELDS_TYPES.DATE,
    AgencyInspection: FIELDS_TYPES.STRING,
    ScopeVerification: FIELDS_TYPES.STRING,
    TypeVerification: FIELDS_TYPES.STRING,
    FieldActivity: FIELDS_TYPES.STRING,
    DepartmentsAudit: FIELDS_TYPES.STRING,
    NameRegulatoryDocument: FIELDS_TYPES.STRING,
    InterestedParties: FIELDS_TYPES.MULTI_USER,
    AmountFine: FIELDS_TYPES.STRING,
    FundsEliminationComments: FIELDS_TYPES.STRING,
    Comments: FIELDS_TYPES.MULTI_STRING,
    DateUpdate: FIELDS_TYPES.DATE,
    PrescriptionStatus: FIELDS_TYPES.LOOKUP,
    ActionStatuses: FIELDS_TYPES.LOOKUP,
    // ActualClosingDatePrescription: FIELDS_TYPES.DATE,
    FrequencyRepeatedNotifications: FIELDS_TYPES.NUMBER,
    PeriodicNotificationUpdateDate: FIELDS_TYPES.STRING,
    ResponsibleEmail: FIELDS_TYPES.STRING,
  },
  [SettingsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Description: FIELDS_TYPES.STRING,
    PathUrl: FIELDS_TYPES.LINK,
    IconUrl: FIELDS_TYPES.LINK,
    UsersGroup: FIELDS_TYPES.MULTI_USER,
  },
  [GOSinstructionsFilesLibName]: {
    ID: FIELDS_TYPES.ID,
    CardID: FIELDS_TYPES.NUMBER,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
  },
  [GOScontactsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Phone: FIELDS_TYPES.STRING,
    Email: FIELDS_TYPES.STRING,
  },
  [licensesList]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    GOSLocation: FIELDS_TYPES.LOOKUP,
    TypeActivity: FIELDS_TYPES.LOOKUP,
    DocumentType: FIELDS_TYPES.LOOKUP,
    NameDocument: FIELDS_TYPES.STRING,
    DocumentNumber: FIELDS_TYPES.STRING,
    startDateDocument: FIELDS_TYPES.DATE,
    ExpirationDateDocument: FIELDS_TYPES.DATE,
    ValidityPeriodDocument: FIELDS_TYPES.STRING,
    DetailedDescription: FIELDS_TYPES.MULTI_STRING,
    GovernmentAgency: FIELDS_TYPES.LOOKUP,
    NamesStateBody: FIELDS_TYPES.STRING,
    Responsible: FIELDS_TYPES.USER,
    InterestedParties: FIELDS_TYPES.MULTI_USER,
    DateUpdate: FIELDS_TYPES.DATE,
    StartDateDocument: FIELDS_TYPES.DATE,
    Comment1: FIELDS_TYPES.MULTI_STRING,
    Products: FIELDS_TYPES.STRING,
    ND: FIELDS_TYPES.STRING,
    Code_TN_VED: FIELDS_TYPES.STRING,
    Code_OKPD: FIELDS_TYPES.STRING,
    CodeTypeAlcoholicBeverages: FIELDS_TYPES.STRING,
    CertificationBody: FIELDS_TYPES.STRING,
    GTD_samples: FIELDS_TYPES.STRING,
    TransferDeclarationBroker: FIELDS_TYPES.STRING,
    // Actions: FIELDS_TYPES.LOOKUP,
    ActionStatuses: FIELDS_TYPES.LOOKUP,
    LicenseStatus: FIELDS_TYPES.LOOKUP,
    ResponsibleEmail: FIELDS_TYPES.STRING,
    IsArchived: FIELDS_TYPES.BOOLEAN,

    FrequencyRepeatedNotifications: FIELDS_TYPES.NUMBER,
    PeriodicNotificationUpdateDate: FIELDS_TYPES.STRING,
  },
  [locationsGos]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Code: FIELDS_TYPES.STRING,
  },
  [directionsGos]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [prescriptionStatusGos]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [actionStatusGos]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [gosViolations]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    ViolationText: FIELDS_TYPES.STRING,
    ParentFormId: FIELDS_TYPES.NUMBER,
  },
  [typeActivity]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [typeDocument]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [licenseStatus]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [agencyGovernment]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [PrescriptionsUpLoad]: {
    ID: FIELDS_TYPES.ID,
    CardID: FIELDS_TYPES.NUMBER,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
    PrescID: FIELDS_TYPES.ID,
  },
  [LicensesUpLoad]: {
    ID: FIELDS_TYPES.ID,
    CardID: FIELDS_TYPES.NUMBER,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
    LicensesID: FIELDS_TYPES.ID,
  },
};

export type MyGoslistNameFieldsRecordType = {
  [prescriptionGos]: {
    ID: number;
    Title: string;
    PrescriptionNumber: string;
    Direction: LookupFields;
    Responsible: UserFields;
    GOSLocation: LookupFields;
    DateVerification: Date;
    DeadlineExecutionOrder: Date;
    AgencyInspection: string;
    ScopeVerification: string;
    TypeVerification: string;
    FieldActivity: string;
    DepartmentsAudit: string;
    NameRegulatoryDocument: string;
    InterestedParties: UserFields;
    AmountFine: string;
    FundsEliminationComments: string;
    Comments: string;
    DateUpdate: Date;
    PrescriptionStatus: LookupFields;
    ActionStatuses: LookupFields;
    // ActualClosingDatePrescription: Date;
    FrequencyRepeatedNotifications: number;
    PeriodicNotificationUpdateDate: string;
    ResponsibleEmail: string;
  };
  [SettingsListName]: {
    ID: number;
    Title: string;
    Description: string;
    PathUrl: UrlFields;
    IconUrl: UrlFields;
  };
  [GOScontactsListName]: {
    ID: number;
    Title: string;
    Phone: string;
    Email: string;
  };
  [GOSinstructionsFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
  };
  [licensesList]: {
    ID: number;
    Title: string;
    GOSLocation: LookupFields;
    TypeActivity: LookupFields;
    DocumentType: LookupFields;
    NameDocument: string;
    DocumentNumber: string;
    startDateDocument: Date;
    ExpirationDateDocument: Date;
    ValidityPeriodDocument: string;
    DetailedDescription: string;
    GovernmentAgency: LookupFields;
    NamesStateBody: string;
    Responsible: UserFields;
    InterestedParties: UserFields;
    DateUpdate: Date;
    StartDateDocument: Date;
    Comment1: string;
    Products: string;
    ND: string;
    Code_TN_VED: string;
    Code_OKPD: string;
    CodeTypeAlcoholicBeverages: string;
    CertificationBody: string;
    GTD_samples: string;
    TransferDeclarationBroker: string;
    // Actions: LookupFields;
    ActionStatuses: LookupFields;
    LicenseStatus: LookupFields;
    ResponsibleEmail: string;
    IsArchived: boolean;

    FrequencyRepeatedNotifications: number;
    PeriodicNotificationUpdateDate: string;
  };
  [locationsGos]: {
    ID: number;
    Title: string;
    Code: string;
  };
  [directionsGos]: {
    ID: number;
    Title: string;
  };
  [prescriptionStatusGos]: {
    ID: number;
    Title: string;
  };
  [actionStatusGos]: {
    ID: number;
    Title: string;
  };
  [gosViolations]: {
    ID: number;
    Title: string;
    ViolationText: string;
    ParentFormId: number;
  };
  [typeActivity]: {
    ID: number;
    Title: string;
  };
  [typeDocument]: {
    ID: number;
    Title: string;
  };
  [licenseStatus]: {
    ID: number;
    Title: string;
  };
  [agencyGovernment]: {
    ID: number;
    Title: string;
  };
  [PrescriptionsUpLoad]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
    PrescID: number;
  };
  [LicensesUpLoad]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
    LicensesID: number;
  };
};

export type MyGoslistNameFieldsType = {
  [prescriptionGos]: {
    ID: number;
    Title: string;
    PrescriptionNumber: string;
    Direction: LookUpRecord;
    Responsible: UserRecord;
    GOSLocation: LookUpRecord;
    DateVerification: Date;
    DeadlineExecutionOrder: Date;
    AgencyInspection: string;
    ScopeVerification: string;
    TypeVerification: string;
    FieldActivity: string;
    DepartmentsAudit: string;
    NameRegulatoryDocument: string;
    InterestedParties: UserRecord;
    AmountFine: string;
    FundsEliminationComments: string;
    Comments: string;
    DateUpdate: Date;
    PrescriptionStatus: LookUpRecord;
    ActionStatuses: LookUpRecord;
    // ActualClosingDatePrescription: Date;
    FrequencyRepeatedNotifications: number;
    PeriodicNotificationUpdateDate: string;
    ResponsibleEmail: string;
  };
  [SettingsListName]: {
    ID: number;
    Title: string;
    Description: string;
    PathUrl: string;
    IconUrl: string;
  };
  [GOScontactsListName]: {
    ID: number;
    Title: string;
    Phone: string;
    Email: string;
  };
  [GOSinstructionsFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
  };
  [licensesList]: {
    ID: number;
    Title: string;
    GOSLocation: LookUpRecord;
    TypeActivity: LookUpRecord;
    DocumentType: LookUpRecord;
    NameDocument: string;
    DocumentNumber: string;
    StartDateDocument: Date;
    ExpirationDateDocument: Date;
    ValidityPeriodDocument: string;
    DetailedDescription: string;
    GovernmentAgency: LookUpRecord;
    NamesStateBody: string;
    Responsible: UserRecord;
    InterestedParties: UserRecord;
    DateUpdate: Date;
    Comment1: string;
    Products: string;
    ND: string;
    Code_TN_VED: string;
    Code_OKPD: string;
    CodeTypeAlcoholicBeverages: string;
    CertificationBody: string;
    GTD_samples: string;
    TransferDeclarationBroker: string;
    // Actions: LookUpRecord;
    ActionStatuses: LookUpRecord;
    LicenseStatus: LookupFields;
    ResponsibleEmail: string;
    IsArchived: boolean;

    FrequencyRepeatedNotifications: number;
    PeriodicNotificationUpdateDate: string;
  };
  [locationsGos]: {
    ID: number;
    Title: string;
    Code: string;
  };
  [directionsGos]: {
    ID: number;
    Title: string;
  };
  [prescriptionStatusGos]: {
    ID: number;
    Title: string;
  };
  [actionStatusGos]: {
    ID: number;
    Title: string;
  };
  [gosViolations]: {
    ID: number;
    Title: string;
    ViolationText: string;
    ParentFormId: number;
  };
  [typeActivity]: {
    ID: number;
    Title: string;
  };
  [typeDocument]: {
    ID: number;
    Title: string;
  };
  [licenseStatus]: {
    ID: number;
    Title: string;
  };
  [agencyGovernment]: {
    ID: number;
    Title: string;
  };
  [PrescriptionsUpLoad]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
    PrescID: number;
  };
  [LicensesUpLoad]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
    LicensesID: number;
  };
};
